export default __webpack_public_path__ + "static/media/body.429010b3.png";